import React, { Component } from "react";
import { Divider, Empty } from "antd";
import PickerMedBox from "../PickerMedBox/PickerMedBox";
import PickerRackLocation from "../PickerRackLocation/PickerRackLocation";
import PickerMedBatches from "../PickerMedBatches/PickerMedBatches";

export class TOPOMedBox extends Component {
  render() {
    let { selectedMed, rackApi, selectedRack } = this.props;

    return (
      <>
        <Divider>Medicine Details</Divider>

        {selectedMed ? (
          <>
            <PickerMedBox selectedMed={selectedMed} />
            <PickerRackLocation rackLocation={selectedRack} rackApi={rackApi} />
          </>
        ) : (
          <Empty style={{ margin: "10vh 0" }} description="No Medicine found" />
        )}
        <PickerMedBatches selectedMed={selectedMed} />
      </>
    );
  }
}
export default TOPOMedBox;
